import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import Marquee from "react-fast-marquee";
import { fadeUp } from "./motion";
import MapLatam from "./MapLatam";

const stats = [
  { value: 15, suffix: "+", label: "Mercados activos" },
  { value: 80, suffix: "", label: "Puertas retail" },
  { value: 15000, suffix: "+", label: "Unidades vendidas 2025" },
  { value: 2, suffix: "", label: "Hubs regionales" },
];

const allMarkets = [
  "Colombia", "Panamá", "Guatemala", "Honduras", "El Salvador", "Nicaragua",
  "Rep. Dominicana", "Bahamas", "Saint Maarten", "Antigua", "Barbados", "Aruba", "Curazao",
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);
  return (
    <span ref={ref}>
      {n.toLocaleString("es-CO")}
      {suffix}
    </span>
  );
};

const Markets = () => (
  <section id="mercados" className="py-24 lg:py-36" data-testid="markets-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="mb-16 lg:mb-24 flex flex-col lg:flex-row lg:items-end justify-between gap-8"
      >
        <div>
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#DB2777]">Mercados</span>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-4">
            De Panamá<br /><span className="font-serif-accent normal-case tracking-normal">al Caribe entero</span><span className="text-[#DB2777]">.</span>
          </h2>
        </div>
        <p className="max-w-md text-base leading-relaxed text-black/60">
          Hub logístico regional en Panamá y oficina comercial clave en
          Colombia. Una red de distribución que cubre Centroamérica y el
          Caribe.
        </p>
      </motion.div>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="mb-20"
      >
        <MapLatam />
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-4 border-t border-black/10">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            custom={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="py-10 lg:py-14 pr-6 border-b border-black/10 md:border-b-0"
            data-testid={`stat-${i}`}
          >
            <span className="font-display font-bold tracking-tighter text-5xl lg:text-6xl block">
              <Counter value={s.value} suffix={s.suffix} />
            </span>
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-black/50 mt-3 block">{s.label}</span>
          </motion.div>
        ))}
      </div>
    </div>

    <div className="mt-20 bg-[#0A0A0A] py-6" data-testid="markets-marquee">
      <Marquee speed={25} autoFill gradient={false} direction="right">
        {allMarkets.map((m) => (
          <span key={m} className="mx-10 flex items-center gap-10 font-display font-semibold uppercase tracking-tight text-2xl text-white/80">
            {m}
            <span className="w-2 h-2 rounded-full bg-[#DB2777] inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);

export default Markets;
